import { createPinia, PiniaVuePlugin } from 'pinia';
const consola = createLogger(__filename);
export default ({
  Vue,
  app
}) => {
  consola.debug('Start Pinia boot');
  app.pinia = createPinia();
  Vue.use(PiniaVuePlugin);
  consola.debug('End Pinia boot');
};